import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../Header";
import AgentGroupItem from "../AgentGroupItem";

import {
  RequestAgentPolicies,
  RequestUpdateAgentPolicy,
} from "../../../../../../store/actions/integrationsActions";

const AgentGroupsForm = ({ selectedHost }) => {
  const dispatch = useDispatch();

  const policy = useSelector((state) => state.integrations.agentPolicy);
  const agentGroups = useSelector((state) => state.integrations.agentGroups);
  const updatePolicyLoading = useSelector((state) => state.integrations.updatePolicyLoading);

  const [agentGroupsUI, setAgentGroupsUI] = useState(agentGroups);

  useEffect(() => {
    if (agentGroups && Object.keys(policy).length > 0) {
      setAgentGroupsUI(
        agentGroups.map((ag) => ({
          ...ag,
          checked: policy.groups.some((pg) => pg === ag.id),
        })),
      );
    }
  }, [agentGroups, policy]);

  const checkItemHandler = (e) => {
    const value = Number(e.target.value);

    setAgentGroupsUI((prevSettings) =>
      prevSettings.map((ps) => (ps.id === value ? { ...ps, checked: !ps.checked } : ps)),
    );
  };

  const checkSaveButtonDisabled = () => {
    if (!policy?.groups || !agentGroupsUI) return true;

    const dbSelected = policy.groups.map((e) => e).sort();

    const uiSelected = agentGroupsUI
      .filter((g) => g.checked)
      .map((g) => g.id)
      .sort();

    if (dbSelected.length !== uiSelected.length) return false;

    return dbSelected.every((id, index) => id === uiSelected[index]);
  };

  const updateAgentGroupsHandler = (e) => {
    e.preventDefault();
    if (updatePolicyLoading) return;

    const groups = agentGroupsUI.filter((ag) => ag.checked).map((filteredAg) => filteredAg.id);

    dispatch(RequestUpdateAgentPolicy({ id: policy.id, groups, host: selectedHost }));
  };

  const toggleStatusHandler = () => {
    dispatch(
      RequestUpdateAgentPolicy({
        id: policy.id,
        enabled: !policy.enabled,
        host: selectedHost,
        onSuccess: () => dispatch(RequestAgentPolicies(selectedHost)),
      }),
    );
  };

  return (
    <>
      <Header
        policy={policy}
        showPolicyInfo={true}
        selectedHost={selectedHost}
        toggleProps={{
          show: true,
          text: "Policy Status",
          active: policy.enabled,
          onClick: toggleStatusHandler,
        }}
      />
      <form className="agent-policy-form">
        <p className="form-label">Assign Agent Groups</p>
        <div className="agent-groups">
          {agentGroupsUI.map((agentGroup) => (
            <AgentGroupItem
              key={agentGroup.id}
              agentGroup={agentGroup}
              onCheck={checkItemHandler}
              checked={agentGroup.checked}
            />
          ))}
        </div>
        <button
          className="primary-button"
          disabled={checkSaveButtonDisabled()}
          onClick={updateAgentGroupsHandler}>
          Save
        </button>
      </form>
    </>
  );
};

export default AgentGroupsForm;
